import Component from '@glimmer/component';

import CAtom from 'rise-ui/components/c-atom.gjs';
import CButton from 'rise-ui/components/c-button.gjs';
import CIcon from 'rise-ui/components/c-icon.gjs';

import nom from 'rise-ui/helpers/nom.js';
import string from 'rise-ui/helpers/string.js';

export default class TimeSeriesSelectionHelpComponent extends Component {
  <template>
    <div class="c-help" ...attributes>
      <p class="c-help__primary">
        Use the controls below to refine your data selections. Available time
        series are listed by location.
      </p>
      <ol class="c-help__list c-ol c-ol--1">
        <li class="c-oli c-oli--1">
          Use the date picker
          <CAtom>(<CButton
            @type="small primary select"
            @classMix="c-dropdown-button"
          ><CIcon
            @icon="add-date"
            @text="Add Date"
          /></CButton>)</CAtom>
          to choose appropriate date ranges for desired time series using one of
          the following methods.
          <ol class="c-help__list c-ol c-ol--2">
            <li class="c-oli c-oli--2">
              Set the default date range to a preset or custom date range.
            </li>
            <li class="c-oli c-oli--2">
              Select a preset or custom date range individually for each time series.
            </li>
          </ol>
        </li>
        <li class="c-oli c-oli--1">
          Use the add button
          <CAtom>(<span class="c-add-button c-add-button--example c-add-button--add-context"></span>)</CAtom>
          to add time series to your query. Click the icon next to the date range
          to remove a time series from your query selection. Note: Selecting a
          date range for an individual time series automatically adds it to your query.
        </li>
        <li class="c-oli c-oli--1">{{nom~}}
          Move on to "{{string "time-series-output-route"}}"
          to visualize or download data.{{nom~}}
        </li>
      </ol>
      {{yield}}
    </div>
  </template>
}
